module.exports = __webpack_public_path__ + "static/media/siauliu-bankas-logo.fe09eda9.svg";